import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id E090B509-20FE-405D-9811-221E533F79F3
 * name book-settings-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-settings-outline.svg
 * tags
 * - Settings 
 */
export const BookSettingsOutlineIcon = createSvgIcon(<><path d="M18 0H6C4.89 0 4 .895 4 2V18C4 19.11 4.89 20 6 20H18C19.11 20 20 19.11 20 18V2C20 .895 19.11 0 18 0M18 18H6V2H8V10L10.5 7.75L13 10V2H18V18M7 22H9V24H7V22M11 22H13V24H11V22M15 22H17V24H15V22Z" /></>, 'BookSettingsOutlineIcon');
export default BookSettingsOutlineIcon